<div class="d-flex row-cols-12">
    <div class="col-12 mt-0">
        <h3 class="title float-start" translate="Permissions.Components.Title"></h3>
    </div>
</div>
<div class="px-4 pt-1 pb-4">
    <ng-container *ngFor="let permissionGroup of permissionGroupValues">
        <ng-container *ngIf="getPermissionGroup(permissionGroup).length > 0">
            <label class="pt-1 pb-2 col-12" translate>Permissions.ConfigurationGroups.{{permissionGroup}}</label>
            <app-permission-list [showWhenHidden]="true"
                                 [permissionGroup]="getPermissionGroup(permissionGroup)"
                                 [level]="level">
            </app-permission-list>
        </ng-container>
    </ng-container>
</div>